import type { BadgeProps } from '@mui/material';
import { Badge } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

import SkeletonLoader from '@components/SkeletonLoader';

interface UnreadBadgeProps {
  /* Number to be displayed within the badge -> number of unread messages or chat rooms */
  unreadCount: number;
  /* Is the badge loading? */
  loading: boolean;
  /* Child components */
  children: ReactNode;
  /* Overriding colour of badge (defaulted to red) */
  color?: BadgeProps['color'];
  /* When false the badge is always hidden regardless of count. */
  show?: boolean;
}

/** Reusable badge component to display the number of unread messages
 * used in UnreadMessageCount (desktop) and MobileBottomMenu (mobile) */
export default function UnreadBadge({
  unreadCount,
  loading,
  children,
  color = 'error',
  show = true,
}: UnreadBadgeProps) {
  return (
    <Badge
      badgeContent={
        <SkeletonLoader
          loading={loading}
          variant="circular"
          width={16}
          height={16}
        >
          {unreadCount}
        </SkeletonLoader>
      }
      color={color}
      invisible={!show || (!loading && unreadCount === 0)}
      showZero={false}
      sx={
        loading
          ? {
              '& .MuiBadge-badge': {
                backgroundColor: 'transparent',
                color: 'transparent',
              },
            }
          : undefined
      }
    >
      {children}
    </Badge>
  );
}
